// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8241 ? "971df74e" : chunkId) + "." + {"150":"90af305d1e2d5ede","4984":"4c2ef04cf1ec3d90","8241":"86a90dde20773623","8909":"de3bc78f1ce280c9","9672":"0578fb8aac027444"}[chunkId] + ".js";
};